import MemriseApi from 'src/api/MemriseApi';
import { RelatedLearnablesResponse } from './schema';

class PublicLearnablesApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/public/learnables' });
  }

  public async getRelatedLearnables(
    learnableId: number | string,
  ): Promise<RelatedLearnablesResponse> {
    return await this.get(`/${learnableId}/related_learnables/`);
  }
}

export const PublicLearnablesApi = new PublicLearnablesApiClass();
